import { Crisp } from "crisp-sdk-web";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { APIProvider } from "./api/APIProvider";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { initViewAsFromUrl } from "./auth/viewAs";

initViewAsFromUrl();

const API_HOST = import.meta.env.VITE_API_HOST;
const escapedEndpoint = API_HOST.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const apiRegex = new RegExp(`^${escapedEndpoint}\\/api`);

// Initialize Crisp with autoload disabled (widget hidden by default)
const CRISP_WEBSITE_ID = import.meta.env.VITE_CRISP_WEBSITE_ID;
if (CRISP_WEBSITE_ID) {
  Crisp.configure(CRISP_WEBSITE_ID, {
    autoload: false,
  });
}

// Sentry.init({
//   enabled: import.meta.env.ENVIRONMENT !== "local",
//   environment: import.meta.env.ENVIRONMENT,
//   dsn: import.meta.env.VITE_SENTRY_DSN,
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   profilesSampleRate: 0.2, // this is relative to tracesSampleRate
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", apiRegex],
//   // Session Replay
//   replaysSessionSampleRate: 0, // Sample rate is currently 100% for development. Lets definitely remember to reduce this for production
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        person_profiles: "always", // Track persons for anonymous users too (needed for funnels)
      }}
    >
      <APIProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </APIProvider>
    </PostHogProvider>
  </React.StrictMode>
);
